import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setWithShippingLabel } from "../lib/draft.lib";

export function useSetWithShippingLabel(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));
  return (withShippingLabel: boolean) => {
    setDraft((prev) =>
      prev ? setWithShippingLabel(prev, withShippingLabel) : prev,
    );
  };
}
